// Generated by scripts/migrate/gen-from-live.py from https://www.dietz.eu/produkte/sonderverpackungen/
// Source of truth is the LIVE page, not the original markdown scrape
// (which was incomplete: this content type was missed entirely, and
// several pages were captured as summaries rather than verbatim copy).
import type { PageEntry } from "@/content/schema";

export const produkteSonderverpackungenDE: PageEntry = {
  id: "product.produkte-sonderverpackungen",
  locale: "de",
  slug: "produkte/sonderverpackungen",
  seo: {
    navLabel: "Sonderverpackungen",
    title: "Sonderverpackungen für technische Federn | Dietz GmbH",
    description:
      "Sonderverpackungen für Federn und Biegeteile – gegurtet, gestapelt oder passend zu Ihrer Montagelinie. Jetzt Angebot anfordern.",
  },
  type: "post",
  h1: "Sonderverpackungen",
  intro: "Um einen sicheren Transport gewährleisten und eine einfache Abnahme der Produkte bei weiteren Industrievorgängen und Montagen zu ermöglichen, liefern wir unsere Federn und Baugruppen werden in Sonderverpackungen. Jegliche denkbare Sonderverpackung wird passgenau auf das jeweilige Produkt abgestimmt, wie z. B. Blister- oder PE-Verpackungen.",
  blocks: [
    { kind: "image", src: "/images/live/DTZ_teaser_sonderverpackungenjpg.jpg", alt: "Sonderverpackungen", width: 800, height: 640 },
    { kind: "heading", level: 2, text: "Schlauchverpackungen" },
    { kind: "paragraph", text: "Druckfedern werden in einer Schlauchverpackung transportiert. Schlauchverpackungen garantieren eine störungsfreie Zuführung bis zur letzten Feder. Baugruppen, Bandbiegeteile oder lasergenerierte Musterteile werden in Blister- oder PE-Verpackungen transportiert, die sie bei Transport und Lagerung schützen." },
    { kind: "heading", level: 2, text: "Anpassung spezifischer Entnahmemechanismen" },
    { kind: "paragraph", text: "Auch bei der Anpassung spezifischer Entnahmemechanismen sind wir Ihnen mit unserem Know-how gern behilflich. Es entfallen dadurch Stillstandzeiten an hochkomplexen Montageanlagen durch ineinander verhakte Federn." },
    { kind: "paragraph", text: "Alle technischen Federn fertigen wir auf Anfrage auch in kleineren Losgrößen. Für alle Produkte werden auch Sonderverpackungen angeboten. Wir verfügen über einen eigenen Werkzeugbau und als Ihr Entwicklungspartner leisten wir für Sie auch individuelle Berechnungen." },
    { kind: "paragraph", text: "Fragen oder Wünsche? Kontaktieren Sie uns!" }
  ],
};
